import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IClassroom } from "../types";

export type IClassroomBalanceSheetQueryParameters = {
    classroom?: RelationalValue<IClassroom>;
};

export type IClassroomBalanceSheetQueryResult = any;

export const classroomBalanceSheetQuery: IApiQueryFunction<IClassroomBalanceSheetQueryParameters> = ({ classroom }) => {
    if (!classroom) {
        return;
    }

    return {
        method: "GET",
        url: `/classrooms/${mapRelationalValue(classroom)}/balance-sheet.csv`,
    };
};

export const useClassroomBalanceSheetQuery = createApiQueryHook<
    IClassroomBalanceSheetQueryParameters,
    IClassroomBalanceSheetQueryResult
>(classroomBalanceSheetQuery);
